import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';


const DownloadFiles16 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial16/tutorial16.zip?ref_type=heads&inline=false', download: 'tutorial16.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialSixtheen = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How To Make File Listing And Text Editing Using QTDesigner And Python3 With Load UI Tutorial</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/KOX_ZvSqG3w/maxresdefault.jpg"
                            alt="Tutorial 16"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    This tutorial shows you how to create a simple file listing and text editing tool using PyQt6, Python3, and Qt Designer. You'll learn how to load a GUI from a .ui file and implement file browsing, display file lists, and edit text content within a QPlainTextEdit widget. This step-by-step guide is perfect for beginners who want to build a basic file manager or text editor using Python and Qt.
                        <br /><strong>What you'll learn:</strong>
                        <ul>
                            <li>Loading .ui files using uic.loadUi</li>
                            <li>Listing files from a directory into a QListWidget</li>
                            <li>Displaying and editing file content in QPlainTextEdit</li>
                            <li>Connecting buttons and signals to load, open, and edit files</li>
                        </ul>
                        Perfect for creating desktop applications involving file browsing and text editing.
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #FileManager #TextEditor #Programming #GUI
                    </p>

                    <button className="seemore">
                        <DownloadFiles16 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialSixtheen;
